import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, contactProfile, groupChartData = [], componentList, performanceAppraisalData = []) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(contactProfile, groupChartData, componentList, performanceAppraisalData),

            styles: {
                header: {
                    fontSize: 20,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 11,
                font: 'SulaimanLipi'
            },

            info: {
                title: "Performance Appraisal"
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (contactProfile, groupChartData, componentList, performanceAppraisalData) => {
        let content = [
            {
                text: 'Performance Appraisal',
                style: 'header',
                alignment: 'center',
                fontSize:12,
                decoration:'underline',
                margin: [0, 0, 5, 10],
                bold: true,
            },
            {
                margin: [5, 10, 5, 5],
                columns: [
                    {
                        width: '50%',
                        stack: [
                            contactProfile.photo64 ? {
                                image: contactProfile.photo64,
                                fit: [80, 80],
                                margin: [0, 0, 0, 5]
                            } : {},
                            { text: contactProfile.full_name, bold: true },
                            { text: `Department: ${contactProfile.department}` },
                            { text: `Designation: ${contactProfile.designation}` },
                            { text: `Employee ID: ${contactProfile.serial_no}` },
                        ]
                    },
                    {
                        width: '50%',
                        stack: (groupChartData && groupChartData.length > 0)
                            ? groupChartData.map(score => ({
                                text: `${score.name}: ${score.score} / ${score.weight}`,
                                margin: [0, 2, 0, 2],
                                bold: true,
                                alignment: 'right'
                            }))
                            : [{ text: '', margin: [0, 2, 0, 2] }]
                    }
                ]
            },
        ];

        componentList.forEach(component => {
            const columns = [
                {
                    text: component.name,
                    bold: true,
                    fontSize: 12,
                    color: '#000',
                    width: '*',
                    margin: [2, 2, 0, 2],
                }
            ];

            if (component.calculation_type !== 'target') {
                columns.push(
                    {
                        text: `Weight: ${component.weight || 0}`,
                        alignment: 'center',
                        width: 80
                    },
                    {
                        text: `Score: ${component.weighted_score || 0}`,
                        alignment: 'right',
                        width: 60
                    }
                );
            }

            content.push({
                columns: columns,
                columnGap: 5,
                margin: [0, 6, 0, 6],
            })

            if (component.active_child && component.active_child.length > 0) {
                const renderFn = (component.calculation_type === 'target')
                    ? renderTargetNodes : renderTreeNodes;

                content.push({
                    stack: renderFn(component.active_child, 0),
                    margin: [0, 4, 0, 8],
                });
            }

            if (component.calculation_type === 'manual' && component.performance_apprisal_master.length > 0) {
                content.push({
                    table: {
                        headerRows: 1,
                        widths: ['*', '*', '*', '*', 'auto'],
                        body: [
                            [
                                { text: 'Reviewer Name & ID', bold: true },
                                { text: 'Reviewer Designation', bold: true },
                                { text: 'Status', bold: true },
                                { text: 'Completion Date', bold: true },
                                { text: 'Score', bold: true, alignment: 'center' },
                            ],
                            ...component.performance_apprisal_master.map(r => [
                                `${r.supervisor_name} (${r.serial_no})`,
                                r.supervisor_designation,
                                r.status,
                                r.completion_date || '',
                                { text: r.score || '0', alignment: 'center' }
                            ])
                        ]
                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return (rowIndex === 0) ? '#f3f2f7' : null;
                        },
                    },
                    margin: [0, 5, 0, 10]
                });
            }

            content.push({
                canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }],
                margin: [0, 5, 0, 5]
            });
        });

        if (performanceAppraisalData && performanceAppraisalData.length > 0) {
            for (const component of performanceAppraisalData) {
                const columns = [
                    {
                        text: component.performance_component_setup.name,
                        bold: true,
                        fontSize: 12,
                        color: '#000',
                        width: '*',
                        margin: [2, 2, 0, 2],
                    },
                    {
                        text: `Weight: ${component.performance_component_setup.weight || 0}`,
                        alignment: 'center',
                        width: 80
                    },
                ];

                content.push({
                    columns: columns,
                    columnGap: 5,
                    margin: [0, 6, 0, 6],
                });

                if (component.performance_component_setup.active_child && component.performance_component_setup.active_child.length > 0) {
                    content.push({
                        stack: renderTreeNodes(component.performance_component_setup.active_child, 0, true),
                        margin: [0, 4, 0, 8],
                    });
                }

                content.push({
                    canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }],
                    margin: [0, 5, 0, 5]
                });
            }
        }

        return content;
    };

    const renderTreeNodes = (nodes, depth = 0, performanceComponent = false) => {
        let result = [];
        nodes.forEach(node => {
            const leftMargin = depth * 15;

            if (node.type === 'group') {
                result.push({
                    text: node.name,
                    bold: true,
                    fontSize: 11,
                    color: '#1C2833',
                    fillColor: '#D6EAF8',
                    margin: [leftMargin, 2, 0, 2],
                    alignment: 'left',
                    border: [false, false, false, true]
                });

                if (node.active_child && node.active_child.length > 0) {
                    result = result.concat(renderTreeNodes(node.active_child, depth + 1, performanceComponent));
                }
            }

            if (node.type === 'endpoint') {
                result.push({
                    columns: [
                        { text: `${node.name}`, margin: [leftMargin, 2, 0, 2], width: '*' },
                        { text: `Weight: ${node.weight || 0}`, fontSize:9, alignment: 'center', width: 80 },
                        {
                            text: 'Score: ' + (
                                performanceComponent
                                    ? (node.performance_apprisal_note_master && node.performance_apprisal_note_master.name
                                            ? node.performance_apprisal_note_master.name + ' (' + (node.score || 0) + ')'
                                            : (node.score || 0)
                                    )
                                    : (node.weighted_score || 0)
                            ),
                            fontSize:9,
                            alignment: 'right',
                            width: performanceComponent ? 110 : 70
                        }
                    ]
                });
            }
        });
        return result;
    };

    const renderTargetNodes = (nodes, depth = 0) => {
        let result = [];

        nodes.forEach(node => {
            const leftMargin = depth * 15;

            if (node.type === 'group') {
                result.push({
                    text: node.name,
                    bold: true,
                    fontSize: 11,
                    color: '#1C2833',
                    fillColor: '#D6EAF8',
                    margin: [leftMargin, 6, 0, 6],
                    alignment: 'left',
                });

                if (node.active_child && node.active_child.length > 0) {
                    result = result.concat(renderTargetNodes(node.active_child, depth + 1));
                }
            }

            if (node.type === 'endpoint') {
                result.push({
                    stack: [
                        {
                            columns: [
                                { text: node.name, width: '*', margin: [leftMargin, 2, 0, 2] },
                                { text: `Target:`, width: 60, fontSize:9, alignment: 'left' },
                                { text: `Qty: ${node.target_qty || 0}`, fontSize:9, width: 50, alignment: 'right' },
                                { text: `Value: ${node.target_value || 0}`, fontSize:9, width: 60, alignment: 'right' },
                                { text: `Remarks: ${node.target_remarks || ''}`, fontSize:9, width: 120, alignment: 'right' },
                            ],
                            margin: [0, 2, 0, 2],
                        },
                        {
                            columns: [
                                { text: '', width: '*', margin: [leftMargin, 0, 0, 2] },
                                { text: `Achievement:`, fontSize:9, width: 60, alignment: 'left' },
                                { text: `Qty: ${node.qty || 0}`, fontSize:9, width: 50, alignment: 'right' },
                                { text: `Value: ${node.value || 0}`, fontSize:9, width: 60, alignment: 'right' },
                                { text: `Remarks: ${node.remarks || ''}`, fontSize:9, width: 120, alignment: 'right' },
                            ],
                            margin: [0, 0, 0, 4],
                        }
                    ],
                    fillColor: '#F8F9F9',
                    margin: [0, 2, 0, 4],
                    padding: [5, 2, 5, 2],
                });
            }
        });

        return result;
    };

    return {
        exportToPDF
    }
}

export default pdfPrinter;